import { Css } from "@homebound/beam";

export const paneShadowWrapper = "paneShadowWrapper";
export const gridRootWrapper = "gridRootWrapper";

export const css = {
  [`.${paneShadowWrapper} > div > div:first-of-type`]: Css.h("calc(100% - 24px)").bshBasic.$,
  [`.${gridRootWrapper} > div:first-of-type`]: Css.w100.$,
};
